<p style="padding: 0% 2%;"><span style="color: gray;" translate>E-Content / Cources / Semester</span> <span
    *ngIf="contentname == ''" translate>/ Subject</span> <span *ngIf="contentname != ''"><span translate>/ Subject</span> / {{contentname}}</span></p>
<div *ngIf="!isViewingDocument" class="d-flex align-items-center" style="padding: 0% 1%;">
  <div style="width: 4%;">
    <button class="back_icon me-2" (click)="navigateToBackPage()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
  </div>
  <div style="width: 66%;">
    <h2 style="margin: 1% 0% 1% 1%;">{{selectesSubjectName}}</h2>
  </div>

  <div style="width: 30%;" *ngIf="actiondata?.create">
    <button style="float: right;" mat-raised-button color="primary" (click)="addecontent()">
      <i class="fa-solid fa-plus"></i>
      <span translate>Add E-Content</span>
    </button>
  </div>
</div>
<app-toast></app-toast>
<div *ngIf="isViewingDocument" class="d-flex align-items-center header">
  <div style="width: 4%;">

    <button class="back_icon me-2" (click)="backToList()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
  </div>
  <div style="width: 66%;">
    <h2 class="page-title mb-0" style="margin-left: 1%;">{{contentname}}</h2>
  </div>
  <div style="width: 30%;">
    <!-- <button mat-mini-fab style="background-color: white;float: right;" class="back" (click)="downloadDocument()">
                <mat-icon style="color: black;">download</mat-icon>
           </button> -->
  </div>
</div>

<section class="container table">
  <!-- List View -->
  <!-- Document Table -->
  <div class="table-responsive" style="border-radius: 15px;" *ngIf="!isViewingDocument">
    <table mat-table [dataSource]="documents" class="mat-elevation-z1 full-width-table">
      <!-- Columns -->
      <ng-container matColumnDef="slno">
        <th mat-header-cell *matHeaderCellDef translate>Sl. no.</th>
        <td mat-cell *matCellDef="let doc;let i = index">{{ i + 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef translate>Document Name</th>
        <td mat-cell *matCellDef="let doc">{{ doc.title }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef>Size</th>
          <td mat-cell *matCellDef="let doc">{{ doc.size }}</td>
        </ng-container> -->

      <ng-container matColumnDef="uploadedDate">
        <th mat-header-cell *matHeaderCellDef translate>Uploaded Date</th>
        <td mat-cell *matCellDef="let doc">
          {{ doc.updated_at | date : "dd-MMM-yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="uploadedBy">
        <th mat-header-cell *matHeaderCellDef translate>Uploaded By</th>
        <td mat-cell *matCellDef="let doc">{{ doc.updated_by }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef translate>Status</th>
        <td mat-cell *matCellDef="let doc">
          <!-- <span
              class="status-badge"
              [ngClass]="{
                approved: doc.status === 'Approved',
                pending: doc.status === 'Pending',
                rejected: doc.status === 'Rejected'
              }"
            >
              {{ doc.status }}
            </span> -->
          <span [ngStyle]="{'color': doc.status === 'UNPUBLISHED'? 'red':'green'}">
            {{ doc.status }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef translate>Type</th>
        <td mat-cell *matCellDef="let doc">
          <div class="d-flex align-items-center">
            <mat-icon class="me-1 view" (click)="handleAction('view', doc.id, doc.title,doc.status)">{{
              getFileTypeIcon(doc.url?doc.url.split('.')[1]:'') }}</mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef translate>Actions</th>
        <td mat-cell *matCellDef="let doc">
          <div *ngIf="actiondata?.create" class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div *ngIf="!actiondata?.create">
            <button matButton class="viewBtn" style="margin-top:2%;"
              (click)="handleAction('view', doc.id, doc.title,doc.status)">
              <span translate>View</span>
            </button>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openAddDialog(dialogTemplate, doc.id, doc.title)">
              <mat-icon>edit</mat-icon> <span translate>Edit</span>
            </button>
            <button mat-menu-item *ngIf="doc.status == 'UNPUBLISHED'"
              (click)="handleAction('edit', doc.id,doc.title,doc.status)">
              <mat-icon>publish</mat-icon><span translate>Publish</span>
            </button>
            <button mat-menu-item *ngIf="doc.status != 'UNPUBLISHED'"
              (click)="handleAction('edit', doc.id,doc.title,doc.status)">
              <mat-icon>unpublished</mat-icon><span translate>Unpublish</span>
            </button>
            <button mat-menu-item (click)="handleAction('delete', doc.id,doc.title,doc.status)">
              <mat-icon>delete</mat-icon> <span translate>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>


  <!-- Document Viewer -->
  <div *ngIf="isViewingDocument" class="container app-container">
    <div class="document-viewer-content">
      <div *ngIf="currentDocumentType === 'image'" class="image-container">
        <img [src]="currentDocumentUrl" alt="Document" class="document-image" />
      </div>

      <div *ngIf="currentDocumentType === 'pdf'" class="pdf-container">
        <iframe [src]="currentDocumentUrl" width="100%" height="600px" style="border: none" title="PDF Document">
        </iframe>
      </div>

      <div *ngIf="currentDocumentType === 'mp4'">
        <video [src]="currentDocumentUrl" controls class="econtent-video"
          poster="https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/common/Placeholders/placeholder_video.svg"></video>
      </div>

      <div *ngIf="
          currentDocumentType === 'word' ||
          currentDocumentType === 'excel' ||
          currentDocumentType === 'powerpoint'
        " class="office-container">
        <iframe [src]="currentDocumentUrl" width="100%" height="600px" style="border: none" title="Office Document">
        </iframe>
      </div>

      <div *ngIf="currentDocumentType === 'unknown'" class="unknown-container">
        <div class="alert alert-info">
          <mat-icon class="me-2">info</mat-icon>
          <span translate>This document type cannot be previewed. Please download the file to view it.</span>
        </div>
        <button mat-raised-button color="primary" (click)="downloadDocument()">
          <mat-icon>download</mat-icon>
          <span translate>Download Document</span>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Dialog Template -->
<ng-template #dialogTemplate>
  <h2 mat-dialog-title translate>Add New Title</h2>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-3">
      <div class="">
        <div *ngFor="let question of questions" class="py-4">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>

      <!-- File Upload -->
      <!-- <div class="mb-3">
        <label class="d-block mb-2 fw-semibold">Upload Document or Image</label>
        <button
          mat-raised-button
          color="accent"
          type="button"
          (click)="fileInput.click(); $event.stopPropagation()"
        >
          Select File
        </button>
        <input
          #fileInput
          type="file"
          hidden
          (change)="onFileSelected($event)"
          (click)="$event.stopPropagation()"
          accept="image/*,application/pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
        />

        <div *ngIf="filePreview && isImage" class="mt-2">
          <img
            [src]="filePreview"
            alt="Preview"
            class="rounded"
            style="max-width: 180px; max-height: 120px"
          />
        </div>

        <div *ngIf="fileName && !isImage" class="mt-2">
          <mat-icon>insert_drive_file</mat-icon>
          <span>{{ fileName }}</span>
        </div>
      </div> -->

      <!-- Dialog Actions -->
      <mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()" translate>Cancel</button>
        <button mat-raised-button color="primary" type="submit" translate>Submit</button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</ng-template>